const placeholderChildren = (isEditor = false, placeholderChildren: Array<any>) => {
  if (isEditor) return placeholderChildren.filter((child) => 'fields' in child);
  else return placeholderChildren;
};

export default placeholderChildren;
